export interface DaoCategory {
  id: string;
  name: string;
  description: string;
  icon: string;
}

export const daoCategories: DaoCategory[] = [
  {
    id: "protocol",
    name: "Protocol DAOs",
    description: "Govern decentralized protocols (DeFi, layer-1/blockchain infrastructure, etc.).",
    icon: "🏛️",
  },
  {
    id: "investment",
    name: "Investment / Venture DAOs",
    description: "Pool capital and make investments collectively.",
    icon: "💰",
  },
  {
    id: "collector",
    name: "Collector / NFT DAOs",
    description: "Collect, fund, or manage NFTs, digital art, or collectibles.",
    icon: "🎨",
  },
  {
    id: "social",
    name: "Social / Community DAOs",
    description: "Organized around shared interests, values, identity, or goals.",
    icon: "👥",
  },
  {
    id: "service",
    name: "Service DAOs",
    description: "Provide services to clients, protocols, or the ecosystem.",
    icon: "🛠️",
  },
  {
    id: "grant",
    name: "Grant / Philanthropy DAOs",
    description: "Fund public goods, open-source development, or social causes.",
    icon: "🧪",
  },
  {
    id: "operating",
    name: "Operating System / Infrastructure DAOs",
    description: "Develop or govern DAO tooling, infrastructure, or coordination protocols.",
    icon: "🏗️",
  },
  {
    id: "governance",
    name: "Governance DAOs (Meta-DAOs)",
    description: "Oversee governance structures of other DAOs or sub-DAOs.",
    icon: "⚖️",
  },
  {
    id: "algorithmic",
    name: "Algorithmic / Autonomous DAOs",
    description: "Run entirely via smart contracts with minimal human intervention.",
    icon: "⚙️",
  },
  {
    id: "hybrid",
    name: "Hybrid DAOs",
    description: "Mix elements of the above categories.",
    icon: "🔀",
  },
];
